// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"01ac98a2","455":"17b8b9b8","977":"6f444f35"}[chunkId] + ".chunk.js";
};